import { createContext, useContext, useState, useEffect } from "react";
import { setupInterceptors } from "../api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const access = localStorage.getItem("accessToken");
    const refresh = localStorage.getItem("refreshToken");
    const role = localStorage.getItem("role");
    return access && refresh ? { access, refresh, role } : null;
  });

  // ذخیره توکن‌ها در لاگین
  const login = (access, refresh, user) => {
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);
    localStorage.setItem("role", user.role);

    setUser({ access, refresh,role: user.role });
  };

  // حذف توکن‌ها در خروج
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    setUser(null);
  };

  // راه‌اندازی axios interceptor برای refresh خودکار توکن‌ها
  useEffect(() => {
    setupInterceptors(logout, login);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        isLoggedIn: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);